import * as React from "react"

import { Layout, Seo } from "@/components"
import ProductBanner from "@/components/product/banner"
import t from "@/constants/wording"
import IconDownloadContent from "./content"

const IconDownload: React.FC = () => {
  return (
    <Layout>
      <Seo
        title="商标下载及使用"
        description="商标下载及使用"
        keywords={t("keywords")}
      />
      <ProductBanner className="logoDownloadBanner" text="商标下载及使用" />
      <IconDownloadContent />
    </Layout>
  )
}

export default IconDownload
